import { GUARANTOR_COMPLIANCE_QUESTIONS } from '@funnels/constants';
import { Question } from '@funnels/types';

export function getPPSGuarantorComplianceDisplayFields(questions: Question[]) {
  const hasBrokerDeclaration = questions.some((q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.BROKER_DECLARATION);
  const hasConfirmCouldMeetLoanRepayments = questions.some(
    (q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.CONFIRM_COULD_MEET_LOAN_REPAYMENTS
  );
  const hasConfirmWouldSellFamilyHome = questions.some(
    (q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.CONFIRM_WOULD_SELL_FAMILY_HOME
  );
  const hasDocumentationDeliveryMethod = questions.some(
    (q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.DOCUMENTATION_DELIVERY_METHOD
  );
  const hasIndependentAdviceTypeRequired = questions.some(
    (q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.INDEPENDENT_ADVICE_TYPE_REQUIRED
  );
  const hasInterviewLocation = questions.some((q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.INTERVIEW_LOCATION);
  const hasInterviewedInPerson = questions.some(
    (q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.INTERVIEWED_IN_PERSON
  );
  const hasIsOnlyPersonPresent = questions.some(
    (q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.IS_ONLY_PERSON_PRESENT
  );
  const hasIsUnderPowerOfAttorney = questions.some(
    (q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.IS_UNDER_POWER_OF_ATTORNEY
  );
  const hasLenderSpecificBrokerDeclaration = questions.some(
    (q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.LENDER_SPECIFIC_BROKER_DECLARATION
  );
  const hasUnderstandsEnglish = questions.some(
    (q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.UNDERSTANDS_ENGLISH
  );
  const hasUnderstandsGuaranteeSigningPeriod = questions.some(
    (q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.UNDERSTANDS_GUARANTEE_SIGNING_PERIOD
  );
  const hasUnderstandsSecurityGuarantee = questions.some(
    (q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.UNDERSTANDS_SECURITY_GUARANTEE
  );

  const hasInterviewDate = questions.some((q: Question) => q === GUARANTOR_COMPLIANCE_QUESTIONS.INTERVIEW_DATE);

  return {
    hasBrokerDeclaration,
    hasConfirmCouldMeetLoanRepayments,
    hasConfirmWouldSellFamilyHome,
    hasDocumentationDeliveryMethod,
    hasIndependentAdviceTypeRequired,
    hasInterviewDate,
    hasInterviewLocation,
    hasInterviewedInPerson,
    hasIsOnlyPersonPresent,
    hasIsUnderPowerOfAttorney,
    hasLenderSpecificBrokerDeclaration,
    hasUnderstandsEnglish,
    hasUnderstandsGuaranteeSigningPeriod,
    hasUnderstandsSecurityGuarantee,
  };
}
